/**
 * The default election for determining settlement price.
 * tag: 42217
 * @readonly
 * @enum {number} (int)
 */
export enum CashSettlPriceDefault {
  Close = 0,
  Hedge = 1,
}
